import './index.css';
import SiteFooter from './components/SiteFooter';
import WebRoutes from './Router';

const App = () => {
  return (
    <>
      <WebRoutes />
      <SiteFooter />
    </>
  );
};

export default App;
